import React, { createContext, forwardRef, useContext } from 'react';

const DrawerContext = createContext();

export const useDrawer = () => useContext(DrawerContext);

const SidebarDrawer = forwardRef(({ children, className, id}, ref) => {

    const closeDrawer = () => {
        if (ref.current) {
            ref.current.checked = false;
        }
    }


    return (
        <DrawerContext.Provider value={closeDrawer}>
            <div className="drawer drawer-end z-[1000] ">
                <input ref={ref} id={id} type="checkbox" className="drawer-toggle" />
                <div className="drawer-side">
                    <label htmlFor={id} aria-label="close sidebar" className="drawer-overlay"></label>
                    <div className="menu p-4 w-80 lg:w-96 min-h-full bg-base-200 text-base-content">
                        {children}
                    </div>
                </div>
            </div>
        </DrawerContext.Provider>
    );
});

export default SidebarDrawer;
